@if (!noFooter) {
  <footer class="w-full mt-4 p-4 flex flex-col justify-center items-center bg-footer text-lightText text-sm">
    <div class="flex flex-col sm:flex-row items-start w-full">
      <div class="flex flex-col w-full sm:w-1/2 sm:justify-end sm:items-end sm:pr-16 order-last sm:order-first mt-4 sm:mt-0">
        <div class="flex flex-col">
          <span class="mb-4">Brauchen Sie Hilfe? Kontaktieren Sie uns gerne:</span>
          <span>{{ legalEntity.name }}</span>
          <span>{{ legalEntity.department }}</span>
          <span>{{ legalEntity.city }}</span>
          <a
            [href]="'tel:' + legalEntity.phone"
            class="mt-2 cursor-pointer underline"
          >
            {{legalEntity.phone}}
          </a>
          <a
            [href]="'mailto:' + legalEntity.email"
            class="mt-2 cursor-pointer underline"
          >
            {{legalEntity.email}}
          </a>
        </div>
      </div>

      <div class="flex flex-col w-full sm:w-1/2 pb-4 sm:pb-0 border-b-2 border-lighterText sm:border-none order-first sm:order-last">
        <div class="flex flex-col max-w-[350px]">
        <span class="mb-4">
          Hier können Sie Ihre Einwilligungserklärung und die Datenschutzinformationen im Detail durchlesen:
        </span>
          <a
            [href]="legalEntity.consentLink(consentVersion)"
            target="_blank"
            class="block cursor-pointer underline"
          >
            <fa-icon class="inline w-[12px] h-[12px] stroke-lightText" [icon]="faChevronRight"></fa-icon>
            Einwilligungserklärung
          </a>

          <a
            [href]="legalEntity.dsiLink(legalEntity.country.defaultConsentVersion)"
            target="_blank"
            class="block mt-2 cursor-pointer underline"
          >
            <fa-icon class="inline w-[12px] h-[12px] stroke-lightText" [icon]="faChevronRight"></fa-icon>
            Datenschutzinformation
          </a>
        </div>
      </div>
    </div>

    <div class="mt-2 sm:mt-0">
      (c) {{ year }} {{legalEntity.vehicleBrand.brandName()}} |&nbsp;
      <a class="underline"
         [href]="legalEntity.vehicleBrand.impressum(legalEntity.country.isAustria)"
         target="_blank"
      >
        Impressum
      </a>
    </div>
  </footer>
}
